<template>
    <div class="form-body without-side">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="img-holder">
            <div class="info-holder">
                <img src="../../assets/images/graphic3.svg" alt="">
            </div>
        </div>
        <div class="form-holder mt-5">
            <div class="form-content">
                <div class="form-items shadow">
                    <div class="website-logo">
                        <router-link to="/">
                            <div class="logo">
                                <img class="logo-size" v-bind:src="imageLogoPath + data.slider_background" alt="">
                            </div>
                        </router-link>
                    </div>
                    <h3>Login to account</h3>
                    <form @submit.prevent="login">
                        <input class="form-control" type="text" name="email" v-model="email" placeholder="E-mail Address" required>
                        <input class="form-control" type="password" name="password" v-model="password" placeholder="Password" required>
                        <router-link class="float-right" to="/reset-password">Forget password?</router-link>
                        <div class="form-button">
                            <button id="submit" type="submit" class="ibtn">Login</button>
                        </div>
                    </form>
                    <div class="other-links">
                        <div class="text">Or</div>
                        <a @click="fbSitelogin" style="cursor:pointer;"><i class="fab fa-facebook-f"></i>Facebook</a>
                        <a @click="googleLogin" style="cursor:pointer;"><i class="fab fa-google"></i>Google</a>
                    </div>
                    <div class="page-links">
                        <router-link to="/signup">Register new account</router-link >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import {
  loadFbSdk,
  getFbLoginStatus,
  fbLogin
} from './../../helpers.js'
export default {
    name: "LoginComponent",
    props: {
        appId: {
        type: String,
        required: true
        },
        version: {
        type: String,
        default: 'v2.10'
        },
        logoutLabel: {
        type: String,
        default: 'Log out from Facebook'
        },
        loginLabel: {
        type: String,
        default: 'Log in to Facebook'
        },
        loginOptions: {
        type: Object,
        default: function() {
            return {
            scope: 'email'
            }
        }
        }
    },
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            email: null,
            password: null,
            data: [],
            tokenKey: '',
            idKey: '',
            userKey: '',
            imagePath: this.$api + "upload/header_logo/",
            imageLogoPath: this.$api + "upload/slider_background/",
            isLogin:false,
            isWorking: false,
            isConnected: false,
            fbName: '',
            fbEmail: '',
            fbPersonalID: '',
        }
    },
    created(){
        this.getHeaderData();
        this.$emit('updateLoginStatus', false); 

        //428841415621648


    },
    mounted(){
        this.$emit('updateLoginStatus', false); 
        loadFbSdk('428841415621648', 'v12.0')
        .then(getFbLoginStatus)
        .then(response => {
            if (response.status === 'connected') {
            this.isConnected = true
            }
            this.isWorking = false
            /** Event `get-initial-status` to be deprecated in next major version! */
            // this.$emit('get-initial-status', response)
            // this.$emit('sdk-loaded', {
            //     isConnected: this.isConnected,
            //     FB: window.FB
            // })
        })
    },
    methods: {
        getHeaderData: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + "api/geek-site"
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.data = response.data.data;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        login: function() {
            this.isLoading = true
            if(!this.email || !this.password) {
                this.isLoading = false
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter e-mail and password!"
                });
            }
            else {
                this.$axios.post(this.$api + "api/geek-buyback-login", {
                    email: this.email,
                    password: this.password
                }).then((response) => {
                    if(response.status == 200) {
                        localStorage.setItem("_token", response.data.token)
                        localStorage.setItem("_id", response.data.data.id)

                        this.$emit('updateLoginStatus', true); 

                        if(this.$route.params.returnCallBack)
                        {
                            this.$router.push({name: this.$route.params.returnCallBack});
                        }
                        else
                        {
                            this.$router.push("/user/dashboard");
                        }   
                    }
                    else {
                        this.isLoading = false
                        this.$swal.fire({
                            icon: "error",
                            text: "Incorrect e-mail and password combination!"
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    this.isLoading = false
                    this.$swal.fire({
                        icon: "error",
                        text: "Incorrect e-mail and password combination!"
                    });
                })
            }
        },
        googleLogin: function() {
            return new Promise((resolve) => {
                resolve(this.$gAuth.signIn());
            }).then((googleUser) => {
                this.isLogin = this.$gAuth.isAuthorized;
                const idToken = googleUser.vc.id_token;
                this.processGoogleLogin(idToken,googleUser);
            });
        },
        processGoogleLogin: function(idToken,googleUser){
                let loggedData = googleUser.getBasicProfile();
                let email = loggedData.ev;
                let fullName = loggedData.qf;
                //return false;
                this.isLoading = true;
                this.$axios.post(this.$api + "api/geek-buyback-social-login",
                { token: idToken,email:email,uName:fullName }).then((response) => 
                {
                    console.log('Res Status = ', response.status);
                    if(response.status == 200) {
                        localStorage.setItem("_token", response.data.token)
                        localStorage.setItem("_id", response.data.data.id)

                        this.$emit('updateLoginStatus', true); 

                        if(this.$route.params.returnCallBack)
                        {
                            this.$router.push({name: this.$route.params.returnCallBack});
                        }
                        else
                        {
                            this.$router.push("/user/dashboard");
                        }   
                    }
                    else {
                        this.isLoading = false
                        this.$swal.fire({
                            icon: "error",
                            text: "Incorrect e-mail and password combination!"
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                    this.$swal.fire({
                        icon: "error",
                        text: "Something went wrong! Please try again."
                    });
                });
        },
        processFacebookLogin: function(idToken,emailData,fullNameData){
                console.log('processFacebookLogin ID= ',idToken);
                console.log('processFacebookLogin email= ',emailData);
                console.log('processFacebookLogin name= ',fullNameData);
                let email = emailData;
                let fullName = fullNameData;
                //return false;
                this.isLoading = true;
                this.$axios.post(this.$api + "api/geek-buyback-social-login",
                { token: idToken,email:email,uName:fullName }).then((response) => 
                {
                    console.log('Res Status = ', response.status);
                    if(response.status == 200) {
                        localStorage.setItem("_token", response.data.token)
                        localStorage.setItem("_id", response.data.data.id)

                        this.$emit('updateLoginStatus', true); 

                        if(this.$route.params.returnCallBack)
                        {
                            this.$router.push({name: this.$route.params.returnCallBack});
                        }
                        else
                        {
                            this.$router.push("/user/dashboard");
                        }   
                    }
                    else {
                        this.isLoading = false
                        this.$swal.fire({
                            icon: "error",
                            text: "Incorrect e-mail and password combination!"
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                    this.$swal.fire({
                        icon: "error",
                        text: "Something went wrong! Please try again."
                    });
                });
        },
        fbSitelogin:function() {
            this.isWorking = true
            fbLogin(this.loginOptions)
                .then(response => {
                    if (response.status === 'connected') {
                        this.isConnected = true
                        window.FB.api('/me', 'GET', { fields: 'id,name,email' },
                            userInformation => {
                                this.fbPersonalID = userInformation.id;
                                this.fbEmail = userInformation.email;
                                this.fbName = userInformation.name;
                                console.log('userInformation.id = ',userInformation.id);
                                console.log('userInformation.email = ',userInformation.email);
                                console.log('userInformation.name = ',userInformation.name);
                                this.processFacebookLogin(this.fbPersonalID,this.fbEmail, this.fbName);
                            }
                        );
                    } else {
                        this.isConnected = false;
                    }
                    this.isWorking = false;
                    console.log(response);

            });
        },
    }
}
</script>

